import {userConstants} from '../../_constants';

export function searchByCrossOwn(state = {}, action) {
  switch (action.type) {
    case userConstants.SEARCH_BY_CROSS_OWN_REQUEST:
      return {
        loading: true,
      };
    case userConstants.SEARCH_BY_CROSS_OWN_SUCCESS:
      return {
        ...action.data,
        loading: false,
      };
    case userConstants.SEARCH_BY_CROSS_OWN_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    case userConstants.RESET_SEARCH_RESULTS:
      return {};

    default:
      return state;
  }
}
